interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const diabeticSupport: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "diabetic-support-iv-drip",
        "meta": {
            "title": "Diabetic Support IV Drip in Dubai | Elite Body Home",
            "description": "Our specialized IV therapy helps manage blood sugar levels, enhance glucose metabolism, and boost energy for people with diabetes.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/diabetic-support-iv-drip/",
            "og": {
                "title": "Diabetic Support IV Drip in Dubai | Elite Body Home",
                "description": "IV therapy to support blood sugar control and diabetes management",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-50.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Diabetic Support IV Drip"],
        "hero": {
            "title": "Diabetic Support IV Drip in Dubai",
            "subtitle": "Blood Sugar Management Therapy",
            "description": "Managing diabetes can be difficult, mainly when keeping the blood sugar level within a specific range, preventing any sort of complications, or maintaining energy are all challenging undertakings. Our Diabetic Support IV Drip is a carefully formulated blends of nutrients that are delivered directly into the bloodstream to support those with diabetes. This IV therapy enhances overall well-being, stimulates insulin secretion, improves glucose metabolism, and increases energy levels."
        },
        "howItWorks": {
            "title": "How This Diabetic Support IV Drip Works",
            "description": "The Diabetic Support IV Drip is a non-surgical treatment that consists of passive perfusion of key vitamins, minerals, and antioxidants delivered through the bloodstream to support blood glucose homeostasis and diabetes wellness."
        },
        "procedureSteps": {
            "heading": "Procedure Overview",
            "para": "Here's what to expect during your Diabetic Support IV Drip session:",
            "steps": [
                {
                    "title": "Intravenous Infusion",
                    "desc": "A thin tube is placed in a vein, generally in an arm, to infuse the nutrient-packed solution straight into the blood vessel.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Duration",
                    "desc": "This process takes roughly 30–60 minutes, and it is tailored to each individual patient's needs.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Personalized Nutrient Formula",
                    "desc": "Its IV drip is tailored with natural components such as magnesium, chromium, vitamin C, and alpha-lipoic acid, that not only contribute to glucose metabolism but also act on insulin sensitivity.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "Relaxing Environment",
                    "desc": "Patients can settle into a stylish environment and enjoy the benefits of an IV drip that provides targeted nutritional support during the treatment.",
                    "icon": "fa-solid fa-couch"
                }
            ]
        },
        "benefits": {
            "heading": "Diabetic Support IV Drip Benefits",
            "subheading": "Experience improved metabolic health and better diabetes management",
            "para": "The Diabetic Support IV Drip helps improve overall metabolic health and manages some of the complications.",
            "items": [
                {
                    "title": "Enhanced Glucose Metabolism",
                    "desc": "Important nutrients such as magnesium and chromium help enhance insulin sensitivity and facilitate better glucose control.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Boosted Energy Levels",
                    "desc": "Low blood sugar levels can be a major cause of fatigue in diabetics, thus, diabetic fatigue is pretty common. This IV drip replenishes lost nutrients and restores energy.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Reduced Oxidative Stress",
                    "desc": "Oxidative stress caused by high blood sugar levels increases the chance of complications. Antioxidants like vitamin C and alpha-lipoic acid protect you from cell damage.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Strengthened Immune Function",
                    "desc": "Diabetes can distort the immune mechanism which leads body prone to infections. The vitamins and antioxidants help bolster immune function.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Benefit from Diabetic Support IV Drip?",
            "subheading": "",
            "para": "Although many individuals with diabetes can avail themselves of the benefits of the Diabetic Support IV Drip, as with any HealthIVF product, you should always ensure that it meets your specific health needs.",
            "items": [
                {
                    "title": "Type 1 and Type 2 Diabetics",
                    "desc": "The drip would benefit both groups, although the formulation might be tweaked a bit, depending on the kind of diabetes.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "People with Prediabetes",
                    "desc": "People who are at risk of diabetes can benefit from this IV therapy to help glucose control for a delayed progression.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "People Experiencing Fatigue",
                    "desc": "When diabetes has resulted in chronic fatigue and low energy, this drip can restore health to the body.",
                    "icon": "fa-solid fa-tired"
                },
                {
                    "title": "People with Poor Glucose Control",
                    "desc": "For people suffering from erratic blood sugar, this IV drip provides nutrients which help stabilize glucose metabolism.",
                    "icon": "fa-solid fa-exclamation-triangle"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before Diabetic Support IV Drip",
            "subheading": "",
            "para": "Preparations Before Diabetic Support IV Drip",
            "items": [
                {
                    "title": "Consult with Your Doctor",
                    "desc": "Talk to a healthcare provider about your diabetic condition and overall health to see whether this therapy is appropriate for you.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Check Blood Sugar Levels",
                    "desc": "The treatment should be done for patients who have well-controlled blood sugar levels to avoid complications during the infusion.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Drinking no less than 1 liter of water before the session will assist not just for the tubes to access the veins, but also with the practicality of the drip.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Medication Management",
                    "desc": "Continue your normal course of medications unless instructed otherwise by your provider.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Eat a Balanced Meal",
                    "desc": "If you are going for your treatment without having a light meal beforehand, you may experience sudden drops in your blood sugar during the appointment.",
                    "icon": "fa-solid fa-utensils"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "Most patients report marked improvement from their Diabetic Support IV Drip, particularly regarding energy levels and blood sugar management.",
            "items": [
                {
                    "title": "Improved Energy and Vitality",
                    "desc": "Many patients say they have more energy and less fatigue for a few days afterward.",
                    "icon": "fa-solid fa-battery-three-quarters"
                },
                {
                    "title": "Better Blood Sugar Control",
                    "desc": "These nutrients regulate glucose infusion to keep blood sugar levels stable over the long run.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Lowered Complication Risks",
                    "desc": "Routine treatments can decrease oxidative stress, increase circulation, and promote general metabolic health, decreasing the risk for diabetes-related complications.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maintain the benefits of your Diabetic Support IV Drip:",
            "items": [
                {
                    "title": "Monitor Blood Sugar",
                    "desc": "Continue monitoring your blood sugar levels as recommended by your doctor.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Maintain Hydration",
                    "desc": "Keep drinking plenty of water to support nutrient absorption and overall health.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Follow Dietary Guidelines",
                    "desc": "Stick to your recommended diabetic diet to complement the IV therapy benefits.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Schedule Follow-ups",
                    "desc": "Consider regular treatments for sustained benefits in blood sugar management.",
                    "icon": "fa-solid fa-calendar-alt"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long does a Diabetic Support IV Drip session take?",
                    "answer": "The infusion process typically takes between 30-60 minutes."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "Patients may feel a small pinch during needle insertion, but the treatment itself is painless."
                },
                {
                    "question": "How soon will I notice results?",
                    "answer": "Many patients report feeling increased energy immediately after the session, with blood sugar benefits developing over time."
                },
                {
                    "question": "How often should I get this treatment?",
                    "answer": "Frequency depends on individual needs - our medical professionals can recommend a schedule during consultation."
                },
                {
                    "question": "Can this replace my diabetes medications?",
                    "answer": "No, this is a supportive therapy and should not replace any medications without consulting your doctor."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/blood-test-in-dubai-1dd-2-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 7,
            "title": "Diabetic Support IV Drip in Dubai",
            "description": "Specialized IV therapy to support blood sugar control and diabetes management with direct nutrient infusion.",
            "price": 699
        }
    },
    "ar": {
        "url": "diabetic-support-iv-drip",
        "meta": {
            "title": "التنقيط الوريدي لدعم مرضى السكري في دبي | ايليت بودي هوم",
            "description": "علاج متخصص لدعم التحكم في مستويات السكر في الدم وتعزيز الصحة الأيضية لمرضى السكري من خلال تركيبة مغذية تعطى مباشرة في الوريد.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/diabetic-support-iv-drip",
            "og": {
                "title": "التنقيط الوريدي لدعم مرضى السكري في دبي | ايليت بودي هوم",
                "description": "علاج وريدي لدعم مرضى السكري وتحسين التحكم في سكر الدم",
                "image": "https://www.elitebodyhome.com/images/diabetic-support-iv-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "التنقيط الوريدي لدعم مرضى السكري"],
        "hero": {
            "title": "التنقيط الوريدي لدعم مرضى السكري",
            "subtitle": "علاج دعم التحكم في سكر الدم",
            "description": "حافظ على توازن جسمك، وارتقِ بصحتك مع التنقيط الوريدي لدعم مرضى السكري. قد تكون إدارة مرض السكري مرهقة، خاصةً عند محاولة الحفاظ على مستويات السكر في الدم ضمن النطاق المطلوب، وتفادي المضاعفات، والحفاظ على الطاقة طوال اليوم. محلول التنقيط الوريدي لدعم مرضى السكري لدينا هو تركيبة مدروسة بعناية من العناصر الغذائية، تُحقن مباشرةً إلى مجرى الدم لدعم الأشخاص المصابين بمرض السكري، وتعمل على تعزيز الصحة العامة، وتحفيز إنتاج الإنسولين، وتحسين عملية التمثيل الغذائي للجلوكوز، ورفع مستويات الطاقة."
        },
        "howItWorks": {
            "title": "كيف يعمل علاج التنقيط الوريدي لدعم مرضى السكري؟",
            "description": "يُعد علاج التنقيط الوريدي لدعم مرضى السكري علاجًا غير جراحي وهو نوع من أنواع العلاج الوريدي بالمغذيات، يتم فيه تزويد الجسم بالفيتامينات والمعادن ومضادات الأكسدة الضرورية مباشرةً عبر مجرى الدم، بهدف دعم توازن مستويات السكر في الدم وتحسين صحة مرضى السكري بشكل عام."
        },
        "procedureSteps": {
            "heading": "خطوات الإجراء",
            "para": "إليك ما يمكن توقعه خلال جلسة العلاج:",
            "steps": [
                {
                    "title": "الحقن الوريدي",
                    "desc": "تُدخل إبرة رفيعة في الوريد، غالبًا في وريد الذراع، لضخ المحلول الغني بالعناصر الغذائية مباشرةً إلى مجرى الدم.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "مدة الجلسة",
                    "desc": "تستغرق الجلسة ما بين 30 إلى 60 دقيقة تقريبًا، وتُصمم حسب احتياجات كل مريض.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "تركيبة من العناصر الغذائية مخصصة",
                    "desc": "يتكون هذا المحلول الوريدي من مكونات طبيعية مثل المغنيسيوم، والكروميوم، وفيتامين سي، وحمض ألفا ليبويك، التي تساهم في تعزيز عملية التمثيل الغذائي للجلوكوز وتحسين حساسية الجسم تجاه الإنسولين.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "بيئة مريحة",
                    "desc": "سيتمكن المرضى من الاسترخاء في بيئة أنيقة والاستفادة من الدعم الغذائي الموجه الذي يقدمه هذا العلاج خلال الجلسة.",
                    "icon": "fa-solid fa-couch"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد العلاج",
            "subheading": "استمتع بتحسين الصحة الأيضية وإدارة أفضل لمرض السكري",
            "para": "يهدف التنقيط الوريدي لدعم مرضى السكري إلى تحسين الصحة الأيضية بشكل عام والمساعدة في السيطرة على بعض المضاعفات المرتبطة بمرض السكري.",
            "items": [
                {
                    "title": "تحسين التمثيل الغذائي للجلوكوز",
                    "desc": "تعمل العناصر الغذائية المهمة مثل المغنيسيوم والكروميوم على تعزيز حساسية الجسم للإنسولين وتنظيم مستوى الجلوكوز في الدم بشكل أكثر فاعلية.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "زيادة مستويات الطاقة",
                    "desc": "يُعد انخفاض سكر الدم من الأسباب الشائعة للشعور بالإرهاق لدى مرضى السكري، سيساعد هذا العلاج على تعويض العناصر الغذائية المفقودة واستعادة النشاط.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تقليل الإجهاد التأكسدي",
                    "desc": "قد يؤدي ارتفاع مستويات السكر في الدم إلى زيادة الإجهاد التأكسدي، مما يرفع خطر حدوث مضاعفات. تعمل مضادات الأكسدة مثل فيتامين سي وحمض الألفا ليبويك على حماية الخلايا من هذا التلف.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "دعم جهاز المناعة",
                    "desc": "يمكن أن يؤثر مرض السكري على كفاءة الجهاز المناعي ويجعل الجسم أكثر عرضة للعدوى. تساعد الفيتامينات ومضادات الأكسدة على تقوية الاستجابة المناعية.",
                    "icon": "fa-solid fa-heartbeat"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية للعلاج",
            "subheading": "",
            "para": "على الرغم من أن العديد من الأشخاص المصابين بالسكري يمكنهم الاستفادة من فوائد العلاج، إلا أنه يجب التأكد دائمًا من أنه مناسب لحالتك الصحية الفردية كما هو الحال مع أي علاج. إليك أهم معايير المرشح المناسب:",
            "items": [
                {
                    "title": "مرضى السكري من النوع الأول والنوع الثاني",
                    "desc": "يُفيد هذا المحلول مرضى السكري من النوعين، مع إمكانية تعديل تركيبته قليلًا حسب نوع مرض السكري.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "الأشخاص المصابون بمقدمات السكري",
                    "desc": "يُعد خيارًا وقائيًا ممتازًا للأشخاص المعرضين لخطر الإصابة بمرض السكري، حيث يساعد في تنظيم مستوى الجلوكوز لتأخير تطور المرض.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "الأشخاص الذين يعانون من الإرهاق",
                    "desc": "قد يسبب مرض السكري الإرهاق المزمن وانخفاض مستويات الطاقة، سيساعد هذا العلاج في استعادة النشاط والحيوية.",
                    "icon": "fa-solid fa-tired"
                },
                {
                    "title": "الأشخاص الذين يعانون من خلل في تنظيم سكر الدم",
                    "desc": "يقدم هذا المحلول الوريدي عناصر غذائية تُساعد على تحسين التوازن في أيض الجلوكوز، لمن يعانون من عدم انتظام مستويات السكر.",
                    "icon": "fa-solid fa-exclamation-triangle"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل الجلسة",
            "subheading": "",
            "para": "إليك خطوات التحضير قبل جلسة التنقيط الوريدي لدعم مرضى السكري:",
            "items": [
                {
                    "title": "استشر طبيبك",
                    "desc": "ناقش حالتك الصحية ومستوى السكر في الدم مع الطبيب المتخصص، لتحديد ما إذا كانت هذه الجلسة مناسبة لك.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "فحص مستويات السكر في الدم",
                    "desc": "يفضل أن تكون مستويات السكر في الدم في المستوى الطبيعي قبل الجلسة، لتفادي أي مضاعفات.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "الحفاظ على ترطيب جسمك",
                    "desc": "احرص على شرب ما لا يقل عن لتر من الماء قبل الجلسة لتسهيل إدخال الإبرة في الوريد، وضمان امتصاص المحلول بفاعلية.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تنظيم الأدوية",
                    "desc": "تابع تناول أدويتك المعتادة ما لم يُطلب منك خلاف ذلك من قبل الطبيب المعالج.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "تناول وجبة متوازنة",
                    "desc": "احرص على تناول وجبة خفيفة ومتوازنة قبل الجلسة، لتجنب الانخفاض المفاجئ في مستوى السكر أثناء العلاج.",
                    "icon": "fa-solid fa-utensils"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "يلاحظ معظم المرضى تحسن واضح بعد جلسات التنقيط الوريدي لدعم مرضى السكري، وخاصةً زيادة مستويات الطاقة وتنظيم السكر في الدم.",
            "items": [
                {
                    "title": "زيادة الطاقة والحيوية",
                    "desc": "يُشير العديد من المرضى إلى شعورهم بزيادة النشاط وتراجع الشعور بالإرهاق لعدة أيام بعد الجلسة.",
                    "icon": "fa-solid fa-battery-three-quarters"
                },
                {
                    "title": "تحسين التحكم في سكر الدم",
                    "desc": "تُساعد العناصر الغذائية الموجودة في المحلول على تنظيم امتصاص الجلوكوز، مما يُساهم في استقرار مستويات السكر في الدم على المدى الطويل.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "تقليل مخاطر المضاعفات",
                    "desc": "يمكن للعلاج المنتظم أن يُخفف من الإجهاد التأكسدي، ويُحسن الدورة الدموية، ويُعزز الصحة الأيضية العامة، مما يُقلل من احتمالية الإصابة بمضاعفات مرتبطة بمرض السكري.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "للحفاظ على فوائد علاج التنقيط الوريدي لدعم مرضى السكري:",
            "items": [
                {
                    "title": "مراقبة سكر الدم",
                    "desc": "استمر في مراقبة مستويات السكر في الدم كما أوصى طبيبك.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "استمر في شرب كميات كافية من الماء لدعم امتصاص العناصر الغذائية والصحة العامة.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "اتباع النظام الغذائي",
                    "desc": "التزم بالنظام الغذائي الموصى به لمرضى السكري لتعزيز فوائد العلاج الوريدي.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "جدولة جلسات المتابعة",
                    "desc": "فكر في الجلسات المنتظمة للحصول على فوائد مستدامة في التحكم في سكر الدم.",
                    "icon": "fa-solid fa-calendar-alt"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تستغرق جلسة التنقيط الوريدي لدعم مرضى السكري؟",
                    "answer": "تستغرق عملية التسريب عادةً ما بين 30 إلى 60 دقيقة."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "قد يشعر المرضى بوخز بسيط عند إدخال الإبرة، لكن العلاج نفسه غير مؤلم."
                },
                {
                    "question": "متى سألاحظ النتائج؟",
                    "answer": "يذكر العديد من المرضى شعورًا بزيادة الطاقة مباشرةً بعد الجلسة، بينما تظهر فوائد التحكم في سكر الدم مع مرور الوقت."
                },
                {
                    "question": "كم مرة يجب أن أحصل على هذا العلاج؟",
                    "answer": "يعتمد التكرار على الاحتياجات الفردية - يمكن لأطبائنا تقديم توصية أثناء الاستشارة."
                },
                {
                    "question": "هل يمكن لهذا العلاج أن يحل محل أدوية السكري؟",
                    "answer": "لا، هذا العلاج داعم ولا يجب أن يحل محل أي أدوية دون استشارة طبيبك."
                }
            ]
        }
    }
}